module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3aa6c6bac36d0bc86fbc48b99e86b7fa.svg";